import { ArrowRight } from "lucide-react";

const Requirements = () => {
  return (
    <section className="container mx-auto py-16">
      <h2 className="font-serif font-bold text-3xl md:text-4xl text-center mb-8">What We Look For</h2>
      <div className="max-w-2xl mx-auto bg-secondary/20 p-8 rounded-xl">
        <ul className="space-y-4">
          <li className="flex items-center gap-3">
            <ArrowRight className="w-5 h-5 text-sunset" />
            <span>Minimum 50% win rate</span>
          </li>
          <li className="flex items-center gap-3">
            <ArrowRight className="w-5 h-5 text-sunset" />
            <span>At least 1500 battles experience</span>
          </li>
          <li className="flex items-center gap-3">
            <ArrowRight className="w-5 h-5 text-sunset" />
            <span>English communication skills</span>
          </li>
          <li className="flex items-center gap-3">
            <ArrowRight className="w-5 h-5 text-sunset" />
            <span>Team players who enjoy division games</span>
          </li>
          <li className="flex items-center gap-3">
            <ArrowRight className="w-5 h-5 text-sunset" />
            <span>Voice Communication is mandatory</span>
          </li>
          <li className="flex items-center gap-3">
            <ArrowRight className="w-5 h-5 text-sunset" />
            <span>Regular Discord Presence</span>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Requirements;